import { atom, computed } from 'nanostores'
import type { Products } from '@forest/native-services'

export const $products = atom<Products | undefined>()

export function setProducts(products: Products) {
  $products.set(products)
}

export const $annualEarlyBirdProduct = computed(
  $products,
  (p) => p?.annualEarlyBird,
)

export type ChinaAndroidTrialEligibility =
  | 'pending'
  | 'available'
  | 'unavailable'

export const $chinaAndroidTrialEligibility =
  atom<ChinaAndroidTrialEligibility>('pending')
